import React, { useMemo } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import BaseModal from '../utils/BaseModal/BaseModal';
import { notifyError, notifyInfo } from '../../../utils/notify';
import { ButtonWrapper, CancelButton, Form, SubmitButton } from './AddUserToCollectionModal.styles';

import { useDispatch, useSelector } from 'react-redux';
import { selectCollectionsActionsPending, selectFetchCollectionsInfo } from '../../../store/slices/collections/slice';
import SelectAlt from '../../utils/SelectAlt/SelectAlt';
import { addUserToCollection } from '../../../store/slices/collections/asyncThunks';

export const editDisplayNameFormSchema = yup
  .object({ collection: yup.mixed().required('Collection is required') })
  .required();

const AddUserToCollectionModal = ({ modalRef, userInfluencerId, onSuccess = () => {}, influencerId }) => {
  const dispatch = useDispatch();
  const { addUserToCollection: addUserToCollectionPending } = useSelector(selectCollectionsActionsPending);

  const { data } = useSelector(selectFetchCollectionsInfo);

  const options = useMemo(() => {
    return data.map(d => ({ label: d.name, value: d._id }));
  }, [data]);

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      collection: null,
    },
    delayError: 300,
    resolver: yupResolver(editDisplayNameFormSchema),
  });

  const onSubmit = data => {
    dispatch(
      addUserToCollection({
        userInfluencerId,
        collectionId: data.collection.value,
        ...(influencerId && { influencerId }),
      }),
    )
      .unwrap()
      .then(() => {
        modalRef.current.hide();
        onSuccess();
        notifyInfo('User added to collection successfully!');
      })
      .catch(err => {
        notifyError(err.message);
      });
  };

  return (
    <BaseModal
      title="Add to Collection"
      ref={modalRef}
      onClose={() => {
        modalRef.current.hide();
      }}
      onAfterClose={() => {
        reset();
      }}>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Controller
          name="collection"
          control={control}
          render={({ field }) => {
            return (
              <SelectAlt
                selectedOption={field.value}
                handleChange={field.onChange}
                label="Collection"
                error={errors.collection?.message}
                options={options}
              />
            );
          }}
        />
        <ButtonWrapper>
          <CancelButton
            title="Cancel"
            onClick={() => {
              reset();
              modalRef.current.hide();
            }}
            type="button"
          />
          <SubmitButton type="submit" title="Save" isLoading={addUserToCollectionPending} />
        </ButtonWrapper>
      </Form>
    </BaseModal>
  );
};

export default AddUserToCollectionModal;
